import { connectedStore } from '../../store';
import getExtensions from '../selectors/extensions';

const applyHook = (name, ...data) => {
  const store = connectedStore.get();

  if (!store) {
    return;
  }

  const state = store.getState();

  const extensions = getExtensions(state);

  if (!extensions) {
    return;
  }

  extensions.forEach((extension) => {
    if (extension.hooks && typeof extension.hooks[name] === 'function') {
      extension.hooks[name](...data);
    }
  });
};

export default applyHook;
